
export const TRACK_HEIGHT = 65
export const APP_HEADER_HEIGHT = 35
export const SAMPLER_HEIGHT = 170
export const SAMPLER_PAD_HEIGHT = 150
export const CTRLS_HEADER_HEIGHT = 55